import type { InputHTMLAttributes } from 'react';
import { SearchIcon } from '../icons/Icons';

type SearchInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/** Grey pill search field with a leading magnifier - the toolbar control in the design. */
export function SearchInput({ className = '', ...props }: SearchInputProps) {
  return (
    <div className={`search-input ${className}`.trim()}>
      <SearchIcon size={16} className="search-input__icon" />
      <input type="search" className="input" {...props} />
    </div>
  );
}
